/**
 login-view
 Created by RuSsCiTy on 07.05.2018
 **/

import Backbone from "backbone";
import { COOKIE_PREFERENCES, PAGES } from "../../../const/constants";
import { mainChannel, viewChannel } from "../../../init/message-hub";
import { isAtLeatOneCookiesOfListAccepted } from "../../../utils/cookie-config-helper";
import { getItem } from "../../../utils/local-storage-util";

const template = require("./template.pug");
require("./style.scss");

export default Backbone.View.extend({
  className: "accept-cookie",
  events: {
    "click .details": "gotoDetails",
    "click .accept-cookie-btn": "acceptCookies",
    "click .toggle-cookie": "toggleCookie",
    "click .cancel-cookie-btn": "cancelCookie"
  },

  initialize(container) {
    this.render(container);
    this.initElements();
  },

  render() {
    this.$el.html(template);
  },

  gotoDetails(e) {
    e.preventDefault();
    e.stopPropagation();
    viewChannel.request("showPage", PAGES.details);
  },

  acceptCookies() {
    mainChannel.request("acceptCookieById", this.cookieId);
    viewChannel.request("togglePreferenceButton", true);
  },

  initElements() {
    this.$cookieId = this.$(".cookie-id");
    this.$cookieUsage = this.$(".cookie-usage");
  },

  reset(options) {
    console.log("options", options);
    this.cookieId = options.cookieId;
    const cookie = mainChannel.request("getCookieById", options.cookieId);
    this.$cookieId.html(cookie.name);
    const language =
      browserData && browserData.language ? browserData.language : "en";
    this.$cookieUsage.html(cookie.usage[language]);
  },

  toggleCookie(e) {
    const cookie = $(e.target).data("cookie");
    const checked = $(e.target).is(":checked");
    const appliedConfig = mainChannel.request("appliedConfig");
    for (let i = 0; i < appliedConfig[cookie].list.length; i++) {
      appliedConfig[cookie].list[i].accepted = checked;
    }
    mainChannel.request("applyConfig", appliedConfig);
  },

  cancelCookie() {
    const cookieAccepted = getItem(COOKIE_PREFERENCES.COOKIE_ACCEPTED);
    if (!cookieAccepted || cookieAccepted === false) {
      viewChannel.request("showPage", PAGES.intro);
    } else {
      viewChannel.request("hide");
      viewChannel.request("togglePreferenceButton", true);
    }
  }
});



// WEBPACK FOOTER //
// ./src-cookie-manager/views/pages/accept-cookie/accept-cookie.js